import { useState, useEffect, useCallback } from "react";
import ReportsService from "@/services/reportsService";

export default function useLoyaltyPointsReport() {
  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({
    totalCustomersWithPoints: 0,
    totalPointsOutstanding: 0,
    pointsEarnedInPeriod: 0,
    pointsRedeemedInPeriod: 0,
    redemptionRate: 0,
    pointsLiabilityValue: 0,
    openingBalance: 0,
    closingBalance: 0,
  });
  const [branchSummary, setBranchSummary] = useState([]);

  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    period: null,
    startDate: null,
    endDate: null,
    branchId: null,
    offset: 0,
    limit: 25,
  });

  const fetchLoyaltyPoints = useCallback(async () => {
    try {
      setLoading(true);

      const res = await ReportsService.getLoyaltyPoints(filters);
      const apiData = res?.data ?? res;

      const rows =
        apiData?.items?.map((row, index) => ({
          id: index + 1,
          customerName: row.customer,
          phone: row.phone,
          openingBalance: Number(row.opening ?? 0),
          pointsEarned: Number(row.earned ?? 0),
          pointsRedeemed: Number(row.redeemed ?? 0),
          pointsExpired: Number(row.expired ?? 0),
          closingBalance: Number(row.balance ?? 0),
          valueInRupees: Number(row.value ?? 0),
          last_activity: row.lastActivity,
          lastRedeemedDate: null,
        })) ?? [];

      setData(rows);

      setSummary({
        totalCustomersWithPoints: Number(
          apiData?.summary?.customersWithPoints ?? 0
        ),
        totalPointsOutstanding: Number(
          apiData?.summary?.pointsOutstanding ?? 0
        ),
        pointsEarnedInPeriod: Number(apiData?.summary?.pointsEarned ?? 0),
        pointsRedeemedInPeriod: Number(apiData?.summary?.pointsRedeemed ?? 0),
        redemptionRate: Number(apiData?.summary?.redemptionRate ?? 0),
        pointsLiabilityValue: Number(apiData?.summary?.liabilityValue ?? 0),
        openingBalance: Number(apiData?.summary?.openingBalance ?? 0),
        closingBalance: Number(apiData?.summary?.closingBalance ?? 0),
      });

      setBranchSummary(apiData?.branchSummary ?? []);
      setTotalItems(apiData?.total ?? 0);
    } catch (err) {
      console.error("useLoyaltyPointsReport ERROR:", err);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    fetchLoyaltyPoints();
  }, [fetchLoyaltyPoints]);

  return {
    data,
    summary,
    branchSummary,
    totalItems,
    loading,
    setFilters,
  };
}
